import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconSecure = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M8.67188 5.15625C8.67188 4.84545 8.54841 4.54738 8.32864 4.32761C8.10887 4.10784 7.8108 3.98438 7.5 3.98438C7.1892 3.98438 6.89113 4.10784 6.67136 4.32761C6.45159 4.54738 6.32812 4.84545 6.32812 5.15625V6.5625H8.67188V5.15625Z",
			fill: "currentColor"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M13.2797 0.95063L7.65469 0.0131303C7.55225 -0.00374608 7.44775 -0.00374608 7.34531 0.0131303L1.72031 0.95063C1.50158 0.987223 1.3029 1.10018 1.15957 1.26942C1.01625 1.43866 0.937565 1.65323 0.9375 1.87501V8.43751C0.9375 10.178 1.6289 11.8472 2.85961 13.0779C4.09032 14.3086 5.75952 15 7.5 15C9.24048 15 10.9097 14.3086 12.1404 13.0779C13.3711 11.8472 14.0625 10.178 14.0625 8.43751V1.87501C14.0624 1.65323 13.9837 1.43866 13.8404 1.26942C13.6971 1.10018 13.4984 0.987223 13.2797 0.95063ZM11.25 10.3125C11.25 10.5611 11.1512 10.7996 10.9754 10.9754C10.7996 11.1512 10.5611 11.25 10.3125 11.25H4.6875C4.43886 11.25 4.2004 11.1512 4.02459 10.9754C3.84877 10.7996 3.75 10.5611 3.75 10.3125V7.50001C3.75 7.25137 3.84877 7.01291 4.02459 6.83709C4.2004 6.66128 4.43886 6.56251 4.6875 6.56251H4.92188V5.15626C4.92188 4.47249 5.1935 3.81674 5.67699 3.33325C6.16048 2.84975 6.81624 2.57813 7.5 2.57813C8.18376 2.57813 8.83952 2.84975 9.32301 3.33325C9.8065 3.81674 10.0781 4.47249 10.0781 5.15626V6.56251H10.3125C10.5611 6.56251 10.7996 6.66128 10.9754 6.83709C11.1512 7.01291 11.25 7.25137 11.25 7.50001V10.3125Z",
			fill: "currentColor"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 15,
			height: 15,
			fill: "white"
		})
	}) })]
});
export default SvgIconSecure;
